import { ICreateComboGroupState } from './createComboGroupContext';
import { CreateComboGroupActionTypes, TCreateComboGroupAction } from './createComboGroupActions';

export const createComboGroupReducer = (
	state: ICreateComboGroupState,
	action: TCreateComboGroupAction,
): ICreateComboGroupState => {
	switch (action.type) {
		case CreateComboGroupActionTypes.CHANGE_VISIBLE_FORM:
			return {
				...state,
				visibleForm: action.payload.visibleForm,
			};
		case CreateComboGroupActionTypes.SET_FETCHED_CUSTOMERS:
			return {
				...state,
				fetchedCustomers: action.payload.customers,
			};
		case CreateComboGroupActionTypes.SET_CUSTOMER:
			return {
				...state,
				selectedCustomer: action.payload.customer,
				fetchedRestaurants: [],
				selectedRestaurants: [],
				fetchedDishes: [],
				selectedDishes: [],
				fetchedComboItems: [],
				selectedComboItems: [],
				defaultCustomerLanguage: null,
				selectedTranslationTab: null,
				translations: [],
			};
		case CreateComboGroupActionTypes.SET_FETCHED_RESTAURANTS:
			return {
				...state,
				fetchedRestaurants: action.payload.restaurants,
			};
		case CreateComboGroupActionTypes.SET_RESTAURANTS:
			return {
				...state,
				selectedRestaurants: action.payload.restaurants,
			};
		case CreateComboGroupActionTypes.SET_FETCHED_DISHES:
			return {
				...state,
				fetchedDishes: action.payload.dishes,
			};
		case CreateComboGroupActionTypes.SET_DISHES:
			return {
				...state,
				selectedDishes: action.payload.dishes,
			};
		case CreateComboGroupActionTypes.CHANGE_NAME:
			return {
				...state,
				name: action.payload.name,
			};
		case CreateComboGroupActionTypes.SET_FETCHED_COMBO_ITEMS:
			return {
				...state,
				fetchedComboItems: action.payload.comboItems,
			};
		case CreateComboGroupActionTypes.SET_COMBO_ITEMS:
			return {
				...state,
				selectedComboItems: action.payload.comboItems,
			};
		case CreateComboGroupActionTypes.CHANGE_UPPER_LIMIT:
			return {
				...state,
				upperLimit: action.payload.upperLimit,
			};
		case CreateComboGroupActionTypes.CHANGE_LOWER_LIMIT:
			return {
				...state,
				lowerLimit: action.payload.lowerLimit,
			};
		case CreateComboGroupActionTypes.SET_FETCHED_TRANSLATIONS:
			return {
				...state,
				translations: action.payload.translations,
				defaultCustomerLanguage: action.payload.defaultCustomerLanguage,
			};
		case CreateComboGroupActionTypes.SET_TRANSLATION_TAB:
			return {
				...state,
				selectedTranslationTab: action.payload.selectedTranslationTab,
			};
		case CreateComboGroupActionTypes.CHANGE_TRANSLATION:
			return {
				...state,
				translations: action.payload.translations,
			};
		case CreateComboGroupActionTypes.SET_DATA_FOR_SUBMIT:
			return {
				...state,
				dataForSubmit: action.payload.dataForSubmit,
			};
		case CreateComboGroupActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW:
			return {
				...state,
				typeOfModalWindow: action.payload.typeOfModalWindow,
			};
		case CreateComboGroupActionTypes.RESET_FIELDS:
			return {
				...state,
				fetchedCustomers: [],
				selectedCustomer: null,
				fetchedRestaurants: [],
				selectedRestaurants: [],
				fetchedDishes: [],
				selectedDishes: [],
				name: '',
				fetchedComboItems: [],
				selectedComboItems: [],
				upperLimit: '',
				lowerLimit: '',
				defaultCustomerLanguage: null,
				selectedTranslationTab: null,
				translations: [],
				dataForSubmit: null,
			};
		default:
			return state;
	}
};
